module.exports = __webpack_public_path__ + "assets/img/wu_du_ren_wu-7befe612.png";